import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceService } from '@app/core/services/invoice.service';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigService } from '@app/core/config/config.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { LateInvoiceGroupModel } from '@app/core/models/invoices/invoice-late-group.model';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';

@Injectable({ providedIn: 'root' })
export class InvoicesLateResolver  {
  constructor(
    private invoiceService: InvoiceService,
    private configService: ConfigService,
    private sessionStorageService: SessionStorageService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<LateInvoiceGroupModel[]> | Promise<LateInvoiceGroupModel[]> | LateInvoiceGroupModel[] {
    const searchFilterKey = route.data.searchFilterKey;

    const searchFilter = this.sessionStorageService.get<any>(searchFilterKey);

    let isReverseFactoring: boolean | null = null;
    if (!_.isNil(searchFilter?.ReverseFactoringSelectedItems)) {
      isReverseFactoring = this.getDropdownValue(searchFilter.ReverseFactoringSelectedItems);
    }

    let isWorkingSituation: boolean | null = null;
    if (!_.isNil(searchFilter?.WorkingSituationSelectedItems)) {
      isWorkingSituation = this.getDropdownValue(searchFilter.WorkingSituationSelectedItems);
    }

    return this.invoiceService.getLateGroupsInvoices(searchFilter?.Delay ?? this.configService.environnement.lateInvoicesDefaultDelay, isReverseFactoring, isWorkingSituation);
  }

  private getDropdownValue(selectedItems: ReferentialItem[]): boolean | null {
    if (_.isNil(selectedItems) || !selectedItems.length) {
      return null;
    }

    return _.head(selectedItems).Id === 1;
  }
}
